import {
    FETCH_HEALTH_SNAPSHOT_LIST,
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY,
    FETCH_HEALTH_SNAPSHOT_SUMMARY,
    FETCH_HEALTH_SNAPSHOT_EPOCH_DATA,
    FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES,
    DELETE_HEALTH_SNAPSHOT_LIST_ITEM,
    UPDATE_HEALTH_SNAPSHOT_LIST_ITEM,
    UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE,
    FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE
} from './ActionTypes';

export function fetchHealthSnapshotList(payload, evictCache) {
    return {
        type: FETCH_HEALTH_SNAPSHOT_LIST,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchHealthSnapshotListByDateRange(payload, evictCache) {
    return {
        type: FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchHealthSnapshotsForDailySummary(payload, evictCache) {
    return {
        type: FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchHealthSnapshotSummary(payload, evictCache) {
    return {
        type: FETCH_HEALTH_SNAPSHOT_SUMMARY,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchHealthSnapshotEpochData(payload, evictCache) {
    return {
        type: FETCH_HEALTH_SNAPSHOT_EPOCH_DATA,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchHealthSnapshotRelativeActivities(payload, evictCache) {
    return {
        type: FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deleteHealthSnapshotListItem(payload) {
    return {
        type: DELETE_HEALTH_SNAPSHOT_LIST_ITEM,
        payload
    };
}

export function updateHealthSnapshotListItem(payload) {
    return {
        type: UPDATE_HEALTH_SNAPSHOT_LIST_ITEM,
        payload
    };
}

export function updateHealthSnapshotItemNote(payload) {
    return {
        type: UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE,
        payload
    };
}
